function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.003,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.003 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,25V5.001h30L0,25Z",
    style: {
      fill: "#009739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.999,5v19.999H0L29.999,5Z",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.999 5.028 29.98 5 22.481 5 0 19.985 0 25 7.623 25 29.999 10.084 29.999 5.028",
    style: {
      fill: "#ffcd00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.539 5 0 21.359 0 24.968 .022 25 5.355 25 29.999 8.57 29.999 5 24.539 5",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.408 18.779 11.113 16.872 9.421 18 7.825 16.739 8.375 18.697 6.683 19.826 8.715 19.908 9.265 21.866 9.971 19.958 12.004 20.04 10.408 18.779",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.51 12.267 23.543 12.349 21.947 11.087 22.653 9.18 20.961 10.308 19.365 9.047 19.915 11.005 18.222 12.134 20.254 12.216 20.804 14.174 21.51 12.267",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/KN.120ffa2c366f9c922e6fb0d37cdea080.svg";
export { ForwardRef as ReactComponent };